import axios from 'axios';
import { appUrl, smlUrl } from '../../../../../utils/config';
import { DELETE_COLLABORATOR_ROLE, DESTROY_BACKDROP, FETCH_ROLES_AND_ACCESS, FETCH_ROLES_AND_ACCESS_LOADING, FETCH_SCREENS_AND_FEATURES_LOADING, OPEN_BACKDROP, UPDATE_COLLABORATOR_ROLE_CHANGES } from '../types';
import { FETCH_SCREENS_AND_FEATURES } from '../types';

export const fetchRolesAndAccess = ({ departmentID, pageNumber=1 , pageSize=5  }) => (dispatch) => {
    // Construct the API URL dynamically
    const apiUrl = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllRoles/${departmentID}/${pageNumber}/${pageSize}`;
    
    // Log the API URL for debugging
    //console.log('API URL:', apiUrl);
  
    axios
      .get(apiUrl)  // Send the GET request to the API
      .then((res) => {
        dispatch({
          type: FETCH_ROLES_AND_ACCESS_LOADING,
          payload: false,
        });
        // throw new Error("mockError")
        // Check if response contains data in the expected format
        if (res.data && res.data?.data?.rolesAndAccessDashboard) {
          // Dispatch the data to the reducer
          dispatch({
            type: FETCH_ROLES_AND_ACCESS,
            payload: {
              status: res.data?.status,
              rolesAndAccessDashboard: res.data?.data?.rolesAndAccessDashboard,
              totalNoOfRecords: res.data?.data?.totalNoOfRecords,
              numberOfPages: res.data?.data?.numberOfPages,
              message: res.data?.data?.message,
            },
          });
        } else {
          dispatch({
            type: FETCH_ROLES_AND_ACCESS_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_ROLES_AND_ACCESS,
            payload: {
              status: false,
              errorDescription: 'No roles found for this department.',
            },
          });
        }
      })
      .catch((err) => {
        console.error('API Error:', err);  // Log the error for debugging
  
        // Handle errors
        if (err?.response?.status === 404) {
          dispatch({
            type: FETCH_ROLES_AND_ACCESS_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_ROLES_AND_ACCESS,
            payload: {
              status: false,
              errorDescription: 'Roles and access not found for the provided parameters.',
            },
          });
        } else {
          dispatch({
            type: FETCH_ROLES_AND_ACCESS_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_ROLES_AND_ACCESS,
            payload: {
              status: false,
              errorDescription: 'Something went wrong. Please contact support.',
            },
          });
        }
      });
  };
  

  
  export const fetchScreensAndFeatures = ({collaboratorRoleID,saas_user_id}) => (dispatch) => {
    axios
      // .get(`${smlUrl}/user/fetchDepartmentDetails`)
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchScreensAndFeatures/${collaboratorRoleID}/${saas_user_id}`)
      .then((res) => {
        dispatch({
          type: FETCH_SCREENS_AND_FEATURES_LOADING,
          payload: false,
        });
        dispatch({
          type: FETCH_SCREENS_AND_FEATURES,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: FETCH_SCREENS_AND_FEATURES_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_SCREENS_AND_FEATURES,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: FETCH_SCREENS_AND_FEATURES_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_SCREENS_AND_FEATURES,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
      });
  };
  

export const updateCollaboratorRoleChanges = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText:"Please don't refresh or close the tab while processing",
  });

  axios
    .post(
     `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateCollaboratorRoleChanges`,
      data
    )
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_COLLABORATOR_ROLE_CHANGES,
          payload: res.data,
        });
      }
    })
    .catch((err) => {
      if (err.response && err.response.status === 400) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_COLLABORATOR_ROLE_CHANGES,
          payload: err.response.data,
        });
      } else if (
        (err.response && err.response.status === 500) ||
        (err.response && err.response.status === 502) ||
        (err.response && err.response.status === 504)
      ) {
        dispatch({
          type: DESTROY_BACKDROP,
        });
        dispatch({
          type: UPDATE_COLLABORATOR_ROLE_CHANGES,
          payload: err.response.data,
        });
      }
    })
};

export const deleteCollaboratorRole = (data) => (dispatch) => {
  dispatch({
    type: OPEN_BACKDROP,
    backdropText: `Please don't refresh or close the tab while processing`,
  });
  axios
    // .get(`${smlUrl}/user/fetchDepartmentDetails`)
    .post(
      `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/deleteCollaboratorRole`,
       data
     )
    .then((res) => {
      if (res.data.status) {
      dispatch({
        type: DELETE_COLLABORATOR_ROLE,
        payload: res.data,
      });
      dispatch({
        type: DESTROY_BACKDROP,
      });
    }
    })
    .catch((err) => {
      if (err?.response?.status === 404) {
        dispatch({
          type: DELETE_COLLABORATOR_ROLE,
          payload: err.response.data,
        });
      } else {
        dispatch({
          type: DELETE_COLLABORATOR_ROLE,
          payload: {
            status: false,
            errorDescription:
              'Something went wrong. Please contact Schrocken Support.',
          },
        });
      }
      dispatch({
        type: DESTROY_BACKDROP,
      });
    });
};









